import { LogApi } from '../types';

const log: LogApi = {
  logErrorScreen(error: string, metadata?: { screenName?: string }) {
    if (this.logApi === undefined) {
      // Return if SDK has not been initialized.
      return;
    }

    this.logApi.logErrorScreen(error, metadata);
  },
};

export { log };
export type { LogApi } from '../types';
